export default "__VITE_ASSET__BoisY4OC__"